import angular from 'angular';

import DateRangePickerComponent from './date-range-picker.cmpt';

export default angular
    .module('application.component.date-range-picker', [])
    .component(DateRangePickerComponent.selector, DateRangePickerComponent);



// WEBPACK FOOTER //
// ./src/application/component/date-range-picker/index.js